import { Platform } from '@angular/cdk/platform';
import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MemoryStorage } from '../class/MemoryStorage';
import { SessionStorageItem } from '../interfaces/item/sessionStorageItem.interface';
import { UserItem } from '../interfaces/item/UserItem.interface';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  sessionStorage: any;

  constructor(@Inject(PLATFORM_ID) platformId: Platform) {
    if (isPlatformBrowser(platformId)) {
      this.sessionStorage = window.sessionStorage;
    } else {
      this.sessionStorage = new MemoryStorage();
    }
  }

  public initSessionStorage(): void {
    if (!this.getSessionStorage()) {
      this.sessionStorage.setItem(environment.sessionStorageKey, JSON.stringify({}));
    }
  }

  public getSessionStorage(): any | null {
    const ss = this.sessionStorage.getItem(environment.sessionStorageKey);
    return ss ? JSON.parse(ss) : null;
  }

  public clearSessionStorage(): void {
    if (this.getSessionStorage()) {
      this.sessionStorage.removeItem(environment.sessionStorageKey);
    }
  }

  public setSessionStorage(value: SessionStorageItem): void {
    this.sessionStorage.setItem(environment.sessionStorageKey, JSON.stringify(value));
  }

  get eventSlug(): string | null {
    return this.getSessionStorage().raceSlug;
  }

  public setEventSlug(slug: string | null): void {
    const ss = this.getSessionStorage();
  }

  get user(): UserItem | null {
    return this.getSessionStorage()?.user;
  }

  get token(): string | undefined {
    return this.getSessionStorage()?.accessToken;
  }

  public setUser(user: UserItem): void {
    const ss = this.getSessionStorage();
    const newValue: SessionStorageItem = { ...ss, user: user };
    this.sessionStorage.setItem(environment.sessionStorageKey, JSON.stringify(newValue))
  }
}
